import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { ClickOutside } from 'ngxtension/click-outside';

@Component({
  selector: 'cf-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownToggle, NgIf, CfIconDirective, NgbDropdownMenu, ClickOutside],
})
export class DropdownComponent {
  placement = input<PlacementArray>('auto');

  showArrow = input<boolean>(false);

  public showMenu = false;

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  closeMenu(): void {
    this.showMenu = false;
  }
}
